'use client'

import Link from 'next/link'
import {
  POPULAR_PERIODS,
  popularPeriodHref,
  type PopularPeriod,
} from '@/lib/popular-period'

export default function PopularPeriodTabs({
  path,
  period,
}: {
  path: string
  period: PopularPeriod
}) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {POPULAR_PERIODS.map((p) => {
        const href = popularPeriodHref(path, p.id)
        const active = period === p.id
        return (
          <Link
            key={p.id}
            href={href}
            className={`rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors sm:text-sm ${
              active
                ? 'bg-[#D92E2E] text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-slate-800 dark:text-gray-200 dark:hover:bg-slate-700'
            }`}
            prefetch={false}
          >
            {p.label}
          </Link>
        )
      })}
    </div>
  )
}
